import Vue from 'vue';
import attendService from '../services/attendService.js';
import { UTCReady, isDateBeforeDate } from '../services/timeUtils';
import postQueue from '../services/postQueue';
import attendSaveQueue from '../services/attendSaveQueue.js';
import { MiniEmp, EmpAttendDisplay, EmpAttend } from '../models.js';
export default {
  state: {
    attend: null,
    monthlyAttends: null,
  },
  getters: {
    empAttends(state, getters, rootState, rootGetters) {
      if (!getters.attendMap || !rootGetters.emps) return [];
      const date = state.attend.date;
      const empsToShow = rootGetters.emps.filter(
        (emp) =>
          (!emp.isSuspend && !emp.exit) || isDateBeforeDate(date, emp.exit),
      );
      return empsToShow.reduce((acc, emp) => {
        const empAttend = getters.attendMap[emp._id];
        acc.push(
          empAttend
            ? { ...empAttend, ...MiniEmp(emp), isAttend: true }
            : { ...EmpAttendDisplay(emp), isAttend: false },
        );
        return acc;
      }, []);
    },
    activeEmpAttends(state, getters, rootState, rootGetters) {
      if (!getters.attendMap || !rootGetters.activeEmps) return [];
      return rootGetters.activeEmps.reduce((acc, emp) => {
        const empAttend = getters.attendMap[emp._id];
        acc.push(
          empAttend
            ? { ...empAttend, ...MiniEmp(emp), isAttend: true }
            : { ...EmpAttendDisplay(emp), isAttend: false },
        );
        return acc;
      }, []);
    },
    monthlyAttends(state, getters, rootState, rootGetters) {
      if (!state.monthlyAttends) return [];
      return state.monthlyAttends.map((emp) => ({
        ...MiniEmp(rootGetters.empMap[emp._id]),
        ...emp,
      }));
    },
    attendMap(state) {
      return (
        state.attend &&
        state.attend.emps.reduce((acc, emp) => {
          acc[emp._id] = emp;
          return acc;
        }, {})
      );
    },
    attend(state) {
      return state.attend;
    },
  },
  mutations: {
    setAttend(state, { attend }) {
      state.attend = attend;
    },
    setmonthlyAttends(state, { attends }) {
      // attends is an array?
      state.monthlyAttends = attends;
    },
    updateEmpAttend(state, { empAttendToUpdate }) {
      if (empAttendToUpdate.isAttend) {
        const updatedEmp = EmpAttend(empAttendToUpdate);
        const empIdx = state.attend.emps.findIndex(
          (emp) => emp._id === empAttendToUpdate._id,
        );
        if (empIdx >= 0) {
          state.attend.emps.splice(empIdx, 1, updatedEmp);
        } else {
          state.attend.emps.push(updatedEmp);
        }
      } else {
        const empIdx = state.attend.emps.findIndex(
          (emp) => emp._id === empAttendToUpdate._id,
        );
        state.attend.emps.splice(empIdx, 1);
      }
    },
  },
  actions: {
    async loadTodayAttend({ rootState, commit, dispatch }) {
      const date = new Date();
      const dateStr = date.toLocaleDateString('en-US');
      if (!rootState.empStore.emps) {
        await dispatch('loadActiveEmps');
      }
      try {
        const attend = await attendService.getDailyAttend(dateStr);
        commit({ type: 'setAttend', attend });
      } catch (err) {
        console.error('Error in loadTodayAttend:', err);
      }
    },
    async loadDailyAttend({ rootState, commit, dispatch }, { date }) {
      const dateStr = date.toLocaleDateString('en-US');
      if (!rootState.empStore.emps) {
        await dispatch('loadEmps', { filterBy: {} });
      }
      try {
        const attend = await attendService.getDailyAttend(dateStr);
        commit({ type: 'setAttend', attend });
      } catch (err) {
        console.error('Error in loadDailyAttend:', err);
      }
    },
    async loadMonthlyAttends(
      { rootState, commit, dispatch },
      { fromDate, toDate },
    ) {
      var filterBy = {};
      if (!rootState.empStore.emps) {
        await dispatch('loadEmps', { filterBy: {} });
      }
      if (fromDate && toDate) {
        fromDate = UTCReady(fromDate);
        toDate = UTCReady(toDate);
        filterBy.fromDate = fromDate ? fromDate.valueOf() : null;
        filterBy.toDate = toDate.valueOf();
      }
      commit('user/toggleLoader', null, { root: true });
      try {
        const attends = await attendService.loadMonthlyAttends(filterBy);
        return commit({ type: 'setmonthlyAttends', attends });
      } catch (err) {
      } finally {
        commit('user/toggleLoader', null, { root: true });
      }
    },
    async updateEmpAttend(context, { empAttendToUpdate }) {
      context.commit({ type: 'updateEmpAttend', empAttendToUpdate });
      const attendDate = context.state.attend.date;
      try {
        await attendService.updateEmpAttend(empAttendToUpdate, attendDate);
      } catch (err) {
        postQueue.addToQueue({
          func: attendService.updateEmpAttend,
          params: [{ empAttendToUpdate, attendId }],
        });
      }
    },
    async updateEmpAttendByDate(context, { empId, date }) {
      const dateStr = date.toLocaleDateString('en-US');
      try {
        const updatedAttend = await attendService.updateEmpAttendByDate(
          empId,
          dateStr,
        );
      } catch (err) {
        attendSaveQueue.addToQueue(empId, dateStr);
      }
    },
  },
};
